// extracted by mini-css-extract-plugin
export default {"features":"features_features__TXRyF","cards":"features_cards__62R2d"};